import React from "react";

const TermsOfServiceForPartners = () => {
  return (
    <div
      className=" lg:w-[920px] w-[353px] mx-auto  flex flex-col gap-14 lg:py-32 py-24 justify-center items-center"
      id="terms-partners"
    >
      <h1 className="text-[#101828] text-2xl font-bold">
        Terms Of Service (DELIVERY PARTNER)
      </h1>
      <div className="flex flex-col gap-14 ">
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            1. INTRODUCTION
          </h3>
          <p className="text-base leading-6">
            <strong>1.1</strong> Welcome to Flit, a hyperlocal delivery service
            platform ("Flit," "we," "us," or "our"). These Terms of Service
            ("Terms") govern your access to and use of our applications,
            websites, content, products, and services (collectively, the
            "Services") as a delivery partner ("you," "Delivery Partner"). By
            registering as a Delivery Partner and using our Services, you agree
            to comply with and be bound by these Terms. If you do not agree to
            these Terms, please do not use our Services.
            <br />
            <strong>1.2</strong> You acknowledge that Flit operates as a
            zero-commission platform, and you are an independent contractor. You
            are responsible for collecting payments directly from customers at
            the pickup or drop-off point, as indicated in the app. Flit does not
            process payouts to Delivery Partners. Instead, you agree to pay a
            small subscription fee based on the model selected by you to access
            and use the platform.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            2. DEFINITION
          </h3>
          <p className="text-base leading-6">
            <strong>2.1</strong> "Account" refers to the user account created by
            you at the time of registration for the purpose of availing Flit's
            Services as a Delivery Partner.
            <br />
            <strong>2.2</strong> "Delivery Request" means a request placed by a
            customer through the Platform for availing Courier Services from a
            Delivery Partner.
            <br />
            <strong>2.3</strong> "Platform" refers to Flit's applications,
            websites, content, products, and services that enable you to access
            and use Flit's Services.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            3. DELIVERY PARTNER RESPONSIBILITIES
          </h3>
          <p className="text-base leading-6">
            <strong>3.1</strong> You agree to perform delivery services in a
            professional, timely, and safe manner in accordance with applicable
            laws and regulations.
            <br />
            <strong>3.2</strong> You are solely responsible for ensuring that
            the deliveries are completed efficiently, and payments are collected
            directly from the customer as per the instructions provided in the
            app.
            <br />
            <strong>3.3</strong> You are responsible for any costs associated
            with your vehicle, fuel, maintenance, insurance, and other
            operational expenses.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            4. PAYMENTS AND SUBSCRIPTION FEES
          </h3>
          <p className="text-base leading-6">
            <strong>4.1</strong> As a Delivery Partner, you are responsible for
            collecting the delivery charges directly from the customer at the
            pickup or drop-off point, as indicated in the app.
            <br />
            <strong>4.2</strong> Flit does not provide payouts or commissions to
            Delivery Partners. Instead, you will be charged a small subscription
            fee based on the model selected by you for accessing and using the
            platform.
            <br />
            <strong>4.3</strong> Subscription fees will be deducted periodically
            as per the selected model, and failure to pay the applicable
            subscription fees may result in suspension or termination of your
            access to the Platform.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            5. CONDUCT AND COMPLIANCE
          </h3>
          <p className="text-base leading-6">
            <strong>5.1</strong> You agree to comply with all applicable laws,
            regulations, and safety standards while performing deliveries.
            <br />
            <strong>5.2</strong> You must not engage in any fraudulent, illegal,
            or unethical activities while using the Services.
            <br />
            <strong>5.3</strong> You are prohibited from misusing customer
            information or engaging in any behavior that may harm the reputation
            of Flit.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            6. SERVICE QUALITY AND CUSTOMER EXPERIENCE
          </h3>
          <p className="text-base leading-6">
            <strong>6.1</strong> You shall ensure courteous and professional
            behavior when interacting with customers.
            <br />
            <strong>6.2</strong> You shall promptly respond to delivery requests
            and provide updates in case of any unforeseen delays.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            7. VEHICLE AND EQUIPMENT REQUIREMENT
          </h3>
          <p className="text-base leading-6">
            <strong>7.1</strong> You must use a well-maintained vehicle that
            complies with safety and legal standards for making deliveries.
            <br />
            <strong>7.2</strong> You are responsible for ensuring that all
            necessary permits, insurance, and documents for operating your
            vehicle are valid and up to date.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            8. LIABILITY FOR DAMAGED, LOST, OR DELAYED DELIVERY
          </h3>
          <p className="text-base leading-6">
            <strong>8.1</strong> If a delivery is delayed due to your
            negligence, you shall be liable for any losses incurred by the
            customer or Flit.
            <br />
            <strong>8.2</strong> In case of damage, loss, or theft of a package
            during delivery, you shall be held financially responsible for
            reimbursing the customer for the value of the lost or damaged goods.
            <br />
            <strong>8.3</strong> Flit reserves the right to initiate legal or
            criminal proceedings against any Delivery Partner involved in
            fraudulent or unlawful activities, including package theft or
            tampering.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            9. ACCOUNT SUSPENSION AND TERMINATION
          </h3>
          <p className="text-base leading-6">
            <strong>9.1</strong> Flit reserves the right to suspend or terminate
            your account if you fail to comply with these Terms, engage in
            fraudulent activities, or violate any applicable laws.
            <br />
            <strong>9.2</strong> If your account is suspended or terminated, you
            shall not be eligible for any refunds on subscription fees paid.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            10. RATINGS AND FEEDBACK
          </h3>
          <p className="text-base leading-6">
            <strong>10.1</strong> Customers may rate your services, and Flit
            reserves the right to take action, including warnings or account
            suspension, based on repeated negative feedback.
            <br />
            <strong>10.2</strong> You may provide feedback regarding your
            experience using the Platform, but any false or misleading
            statements may lead to account termination.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            11. INDEMNIFICATION
          </h3>
          <p className="text-base leading-6">
            <strong>11.1</strong> You agree to indemnify and hold Flit harmless
            from any claims, damages, or legal actions arising from your conduct
            as a Delivery Partner.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            12. LIMITATION OF LIABILITY
          </h3>
          <p className="text-base leading-6">
            <strong>12.1</strong> Flit is not responsible for any loss, damage,
            or liability arising from your use of the Platform or delivery
            services performed by you.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            13. MODIFICATION OF TERMS
          </h3>
          <p className="text-base leading-6">
            <strong>13.1</strong> Flit reserves the right to modify these Terms
            at any time, and any changes will be communicated to you through the
            Platform.
            <br />
            <strong>13.2</strong> Continued use of the Platform after the
            modifications shall constitute your acceptance of the revised Terms.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            14. GOVERNING LAW AND JURISDICTION
          </h3>
          <p className="text-base leading-6">
            <strong>14.1</strong> These Terms shall be governed by and construed
            in accordance with the laws of Bangalore, India.
            <br />
            <strong>14.2</strong> Any disputes arising from these Terms shall be
            subject to the exclusive jurisdiction of the courts in Bangalore,
            India.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            15. FORCE MAJEURE
          </h3>
          <p className="text-base leading-6">
            <strong>15.1</strong> Flit shall not be held liable for any failure
            or delay in service due to events beyond reasonable control,
            including natural disasters, government actions, or technical
            failures.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">16. NOTICES</h3>
          <p className="text-base leading-6">
            <strong>16.1</strong> All notices and communications shall be
            conducted through the Platform or via the contact information
            provided in your Account.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">17. WAIVER</h3>
          <p className="text-base leading-6">
            <strong>17.1</strong> Failure by either party to enforce any right
            or provision of these Terms shall not constitute a waiver of future
            enforcement of that right or provision.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            18. ASSIGNMENT
          </h3>
          <p className="text-base leading-6">
            <strong>18.1</strong> You may not assign or transfer your rights or
            obligations under these Terms without Flit's prior written consent.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            19. ACKNOWLEDGEMENT
          </h3>
          <p className="text-base leading-6">
            <strong>19.1</strong> By registering as a Delivery Partner and using
            Flit's Services, you acknowledge that you have read, understood, and
            agree to be bound by these Terms.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-[#131D2D]">
            Contact Information
          </h3>
          <p className="text-base leading-6">
            If you have any questions or concerns about these Terms, please
            contact us at: <br />
            <strong>Email:</strong>{" "}
            <a
              href="mailto:support@goflash.in"
              className="text-blue-600 underline"
            >
              support@goflash.in
            </a>{" "}
            <br />
            <strong>Phone:</strong>{" "}
            <a href="tel:+917045063838" className="text-blue-600 underline">
              +91 70450 63838
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceForPartners;
